import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const SettingsLink = styled(Link)`
  text-decoration: none;
`;
